// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6547) return "static/chunks/6547-da8203f1579bcf48.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"1167":"396654d297662376","1285":"da7930f3421ef9cc","2754":"5d8413a58beaf423","2937":"9f346c793cd10593","5279":"0db13883e9f0db67","7170":"028520953503d610","7229":"10e7a4732f059361"}[chunkId] + ".js";
};